import { APP_DEVICE_ID_STORAGE_KEY } from 'configs/android'
import AndroidHandler from 'utils/androidHandler'
import { useAuth } from 'utils/auth'
import { deviceType } from 'utils/deviceType'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import { useSatuEventTracker } from 'utils/satuEvent'

import type { TSETrackEventDefaultAtributes } from 'types/pendaftaran-ikm'

const SATU_EVENT_NAME = 'guru_core_pwa_event_tracker_v1'
const TRACKER_EVENT_NAME = 'GURU_CORE_APP'
const TRACKER_SCREEN_NAME = 'HOMEPAGE'
const DEFAULT_TIMEOUT = 5000 // 5 seconds

export const useSETrackEvent = () => {
  const [, , , getAppDeviceIdValue] = useLocalStorage(
    APP_DEVICE_ID_STORAGE_KEY,
    null
  )

  const appDeviceID = getAppDeviceIdValue()
  const hasAppDeviceID = Boolean(appDeviceID)
  const androidHandler = AndroidHandler()
  const { session } = useAuth()
  const { SETrackEvent, SETransformAttrs } = useSatuEventTracker()

  const SETrackEventDefaultAtributes: TSETrackEventDefaultAtributes = {
    screen_name: TRACKER_SCREEN_NAME,
    is_login: [Boolean(session), 'bool'],
    is_webview: [androidHandler.enabled, 'bool'],
  }

  const SETrackComponent = (
    activity_type: string,
    additionalAttributes?: Record<string, any>
  ): void => {
    SETrackEvent({
      eventName: SATU_EVENT_NAME,
      eventParams: {
        activity_type,
        event_name: TRACKER_EVENT_NAME,
        user_id: session?.user?.id,
        ...(hasAppDeviceID ? { device_id: appDeviceID } : {}),
        attributes: SETransformAttrs({
          ...SETrackEventDefaultAtributes,
          event_trigger: TRACKER_SCREEN_NAME,
          ...additionalAttributes,
        }),
      },
      timeout: DEFAULT_TIMEOUT,
      keepAlive: true,
    })
  }

  const SETrackOpenInformationDetails = ({
    page_name,
    image_link,
    announcement_id,
  }): void => {
    SETrackComponent('OPEN_INFORMATION_DETAILS', {
      event_trigger: 'http://guru.kemdikbud.go.id/info-terkini',
      screen_name: '',
      page_name: page_name,
      user_email: session?.user?.email ?? null,
      device: deviceType(),
      page_element: JSON.stringify({
        image: image_link,
        announcement_id: announcement_id,
      }),
    })
  }

  const SETrackShareInformation = ({
    event_trigger,
    announcement_id,
  }): void => {
    SETrackComponent('CLICK_SHARE_BUTTON', {
      event_trigger,
      screen_name: '',
      user_email: session?.user?.email ?? null,
      device: deviceType(),
      page_element: JSON.stringify({
        announcement_id,
      }),
    })
  }

  const SETrackShareMediaClick = ({
    event_trigger,
    announcement_id,
    funnel,
  }): void => {
    SETrackComponent('CLICK_MEDIA_BUTTON', {
      event_trigger,
      screen_name: '',
      user_email: session?.user?.email ?? null,
      device: deviceType(),
      page_element: JSON.stringify({
        announcement_id,
        funnel,
      }),
    })
  }

  return {
    SETrackOpenInformationDetails,
    SETrackShareInformation,
    SETrackShareMediaClick,
  }
}
